export default [
  {
    title: 'Dashboard',
    route: 'A-Dashboard',
    icon: 'AirplayIcon',
    resource: 'R0',
    action: 'read',
  },
  {
    title: 'Voucher',
    route: 'Voucherlist',
    icon: 'FileIcon',
    resource: 'R500',
    action: 'read',
  },
  {
    title: 'Mail-Voucher',
    route: 'MailVoucherList',
    icon: 'MailIcon',
    resource: 'R2',
    action: 'read',
  },
  {
    title: 'Dispo',
    route: 'DispositionList',
    icon: 'AlignRightIcon',
    resource: 'R400',
    action: 'read',
  },
  {
  title: 'Kalender',
  route: 'Kalender',
  icon: 'CalendarIcon',
  resource: 'R400',
  action: 'read'
  },
  {
    title: 'Kontrolle',
    route: 'VoucherConfirm',
    icon: 'CheckCircleIcon',
    resource: 'R500',
    action: 'read',
  },
  {
    title: 'Kostenübersicht',
    route: 'TaxOffice',
    icon: 'DollarSignIcon',
    resource: 'R10',
    action: 'read',
  },
  {
    title: 'Rechnungnskunden',
    route: 'customerList',
    icon: 'AlignLeftIcon',
    resource: 'R700',
    action: 'read',
  },
  {
    title: 'Rechnungen',
    route: 'BillingList',
    icon: 'DollarSignIcon',
    resource: 'R600',
    action: 'read'
  },
  {
    title: 'Stammkunden',
    route: 'AddressTemplate',
    icon: 'AlignJustifyIcon',
    resource: 'R550',
    action: 'read',
  },
  {
    title: 'Angebot',
    route: 'AddOfferMask2',
    icon: 'AlignJustifyIcon',
    resource: 'R500',
    action: 'read',
  },
  /*{
    title: 'Krankenfahrten',
    route: 'MedicalTripList',
    icon: 'AlignJustifyIcon',
    resource: 'R500',
    action: 'read',
  },*/
  {
    title: 'Serienfahrten',
    route: 'SerialBookingList',
    icon: 'AlignJustifyIcon',
    resource: 'R2',
    action: 'read',
  },
  {
    title: 'Ki',
    route: 'KiPdf',
    icon: 'AlignJustifyIcon',
    resource: 'R2',
    action: 'read',
  },
  /*{
    title: 'Notizblock',
    route: 'Notepad',
    icon: 'AlignJustifyIcon',
    resource: 'R0',
    action: 'read',
  },*/
  {
    title: 'Logs',
    route: 'Logs',
    icon: 'AlignJustifyIcon',
    resource: 'R30',
    action: 'read',
    children: [
      {
        title: 'Mail',
        route: 'MailLogList',
        icon: 'BriefcaseIcon',
        resource: 'R30',
        action: 'read',
      },
      {
        title: 'Account Logs',
        route: 'AccountLogs',
        icon: 'BriefcaseIcon',
        resource: 'R30',
        action: 'read',
      },
      {
        title: 'Pdf Queue',
        route: 'PdfQueueLogList',
        icon: 'BriefcaseIcon',
        resource: 'R30',
        action: 'read',
      },
      {
        title: 'System',
        route: 'SystemLogs',
        icon: 'BriefcaseIcon',
        resource: 'R30',
        action: 'read',
      },
    ],
  },

  {
    title: 'Buchhaltung',
    route: 'taxoffice',
    icon: 'AlignJustifyIcon',
    resource: 'R10',
    action: 'read',
    children: [
      {
        title: 'Kasse',
        route: 'TaxofficeCashList',
        icon: 'BriefcaseIcon',
        resource: 'R10',
        action: 'read',
      },
      {
        title: 'Giro',
        route: 'TaxofficeGiroList',
        icon: 'BriefcaseIcon',
        resource: 'R10',
        action: 'read',
      },
      {
        title: 'Sumup',
        route: 'SumUp PayOuts',
        icon: 'BriefcaseIcon',
        resource: 'R10',
        action: 'read',
      },
      {
        title: 'Kassenzettel erfassen',
        route: 'CreateSevdeskVoucher',
        icon: 'BriefcaseIcon',
        resource: 'R10',
        action: 'read',
      },
    ],
  },
  {
    title: 'Fahrer / Fahrzeuge',
    icon: 'AlignJustifyIcon',
    resource: 'R0',
    action: 'read',
    children: [
      {
        title: 'Fahrerliste',
        route: 'Driver',
        icon: 'BriefcaseIcon',
        resource: 'R100',
        action: 'read',
      },
      {
        title: 'Fahrerstunden',
        route: 'DriverVoucher',
        icon: 'BriefcaseIcon',
        resource: 'R30',
        action: 'read',
      },
      {
        title: 'Fahrzeuge',
        route: 'Vehicle',
        icon: 'TruckIcon',
        resource: 'R820',
        action: 'read',
      },
    ],
  },
  {
    title: 'Anrufliste',
    route: 'CallList',
    icon: 'AlignJustifyIcon',
    resource: 'R570',
    action: 'read',
  },
  {
    title: 'Einstellungen',
    route: 'settings',
    icon: 'SettingsIcon',
    children: [
      {
        title: 'Flüge',
        route: 'FlightPlanList',
        icon: 'BriefcaseIcon',
        resource: 'R200',
        action: 'read',
      },
      {
        title: 'Pushover',
        route: 'Pushover',
        icon: 'BellIcon',
        resource: 'R10',
        action: 'read',
      },
      {
        title: 'Preise',
        route: 'PriceList',
        icon: 'DollarSignIcon',
        resource: 'R630',
        action: 'read',
      },
      {
        title: 'E-Mail Templates',
        route: 'MailTemplateList',
        icon: 'MailIcon',
        resource: 'R10',
        action: 'read',
      },
      {
        title: 'Berechtigungen',
        route: 'Users',
        icon: 'LockIcon',
        resource: 'R10',
        action: 'read',
      },
    ],
  },
  {
    title: 'Fehlerbehebung',
    route: 'FixHelper',
    icon: 'AlignJustifyIcon',
    resource: 'R0',
    action: 'read',
  },
]
